import React from 'react';
import { HiOutlineMagnifyingGlassPlus } from 'react-icons/hi2';

function DetailButton() {
  // eslint-disable-next-line jsx-a11y/control-has-associated-label
  return <button className="btn btn-sm btn-info" type="button"><HiOutlineMagnifyingGlassPlus /></button>;
}

export default DetailButton;
